import axios from "axios";

export default {
  methods: {
    rest_getSessionId() {
      console.log("getSessionId");

      let jreq = { sessionId: this.$store.state.appSessionID };
      let request = JSON.stringify(jreq);

      return axios
        .post(this.$store.state.apiUrl + "sessionId", request, this.$store.state.httpReqOpt)
        .then(result => result.data)
        .then(data => {
          return data.sessionId;
        })
        .catch(error => {
          console.log(error);
          return null;
        });
    },

    rest_initApp(paramKey) {
      let jreq = paramKey;
      let request = JSON.stringify(jreq);

      return axios
        .post(this.$store.state.doApiUrl + "init", request, this.$store.state.httpReqOpt)
        .then(result => result.data)
        .then(data => {
          return data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    rest_getStores() {
      return this.isSessionValid().then(valid => {
        if (!valid) return null;

        let jreq = {
          sessionId: this.$store.state.appSessionID,
          sessionKey: this.$store.state.appSessionKey,
          app: this.$store.getters.appInfo,
        };
        let request = JSON.stringify(jreq);

        return axios
          .post(this.$store.state.doApiUrl + "v2/getstores", request, this.$store.state.httpReqOpt)
          .then(result => result.data)
          .then(data => {
            return data;
          })
          .catch(error => {
            console.log(error);
          });
      });
    },

    rest_getStore(storeSessionKey) {
      return this.isSessionValid().then(valid => {
        if (!valid) return null;

        let jreq = {
          sessionId: this.$store.state.appSessionID,
          sessionKey: storeSessionKey,
          app: this.$store.getters.appInfo,
        };
        let request = JSON.stringify(jreq);

        return axios
          .post(this.$store.state.doApiUrl + "getstore", request, this.$store.state.httpReqOpt)
          .then(result => result.data)
          .then(data => {
            return data;
          })
          .catch(error => {
            console.log(error);
          });
      });
    },

    rest_isServerOnline() {
      if (this.$store.getters.notCheckServerOnline) {
        return new Promise(resolve => {
          resolve({ result: "ok" });
        });
      } else
        return this.isSessionValid().then(valid => {
          if (!valid) return null;

          let jreq = { sessionId: this.$store.state.appSessionID, sessionKey: this.$store.state.store.sessionKey };
          let request = JSON.stringify(jreq);

          return axios
            .post(this.$store.state.doApiUrl + "isonline", request, this.$store.state.httpReqOpt)
            .then(result => result.data)
            .then(data => {
              return data;
            })
            .catch(error => {
              console.log(error);
            });
        });
    },

    rest_getServerStatus() {
      return this.isSessionValid().then(valid => {
        if (!valid) return null;

        let jreq = { sessionId: this.$store.state.appSessionID, sessionKey: this.$store.state.store.sessionKey };
        let request = JSON.stringify(jreq);

        return axios
          .post(this.$store.state.doApiUrl + "getserverstatus", request, this.$store.state.httpReqOpt)
          .then(result => result.data)
          .then(data => {
            return data;
          })
          .catch(error => {
            console.log(error);
          });
      });
    },

    rest_getFullMenu(menuType, priceLevel) {
      return this.isSessionValid().then(valid => {
        if (!valid) return null;

        let jreq = {
          sessionId: this.$store.state.appSessionID,
          sessionKey: this.$store.state.store.sessionKey,
          app: this.$store.getters.appInfo,
          menuTypes: [menuType],
          priceLevel: priceLevel,
        };
        let request = JSON.stringify(jreq);

        return axios
          .post(this.$store.state.doApiUrl + "v2/getfullmenu", request, this.$store.state.httpReqOpt)
          .then(result => result.data)
          .then(data => {
            return data;
          })
          .catch(error => {
            console.log(error);
            return null;
          });
      });
    },

    rest_getTable(params) {
      return this.isSessionValid().then(valid => {
        if (!valid) return null;

        let tableID = params.tableID;
        let tableName = params.tableName;
        if ((tableID == null || tableID == 0) && (tableName == null || tableName == "")) return null;

        let sessionKey = params.sessionKey;
        if (sessionKey == null && this.$store.state.store != null) sessionKey = this.$store.state.store.sessionKey;
        let jreq = {
          sessionId: this.$store.state.appSessionID,
          sessionKey: sessionKey,
          tableID: tableID,
          tableName: tableName,
          get: ["tables"],
        };
        let request = JSON.stringify(jreq);

        return axios
          .post(this.$store.state.doApiUrl + "getdata", request, this.$store.state.httpReqOpt)
          .then(result => result.data)
          .then(data => {
            return data;
          })
          .catch(error => {
            console.log(error);
            return null;
          });
      });
    },

    rest_getCategories(menuType, catID) {
      return this.isSessionValid().then(valid => {
        if (!valid) return null;

        let jreq = {
          sessionId: this.$store.state.appSessionID,
          sessionKey: this.$store.state.store.sessionKey,
          menuTypes: [menuType],
          catID: catID,
          menu: true,
        };
        let request = JSON.stringify(jreq);

        return axios
          .post(this.$store.state.doApiUrl + "getcategories", request, this.$store.state.httpReqOpt)
          .then(result => result.data)
          .then(data => {
            return data;
          })
          .catch(error => {
            console.log(error);
          });
      });
    },

    rest_getItems(menuType, cat, bundleMenu = false) {
      return this.isSessionValid().then(valid => {
        if (!valid) return null;

        let jreq = {
          sessionId: this.$store.state.appSessionID,
          sessionKey: this.$store.state.store.sessionKey,
          menuTypes: [menuType],
          catID: cat.ID,
          favorite: cat.favorite,
          redeem: cat.redeem,
          redeemable: cat.redeemable,
          menu: true,
          bundlemenu: bundleMenu,
        };
        let request = JSON.stringify(jreq);

        return axios
          .post(this.$store.state.doApiUrl + "getitems", request, this.$store.state.httpReqOpt)
          .then(result => result.data)
          .then(data => {
            return data;
          })
          .catch(error => {
            console.log(error);
          });
      });
    },

    rest_getItemSoldout(items) {
      return this.isSessionValid().then(valid => {
        if (!valid) return null;

        let jreq = {
          sessionId: this.$store.state.appSessionID,
          sessionKey: this.$store.state.store.sessionKey,
          items: items,
        };
        let request = JSON.stringify(jreq);

        return axios
          .post(this.$store.state.doApiUrl + "v2/getitemsoldout", request, this.$store.state.httpReqOpt)
          .then(result => result.data)
          .then(data => {
            return data;
          })
          .catch(error => {
            console.log(error);
          });
      });
    },

    rest_sendOrder(feed) {
      return this.isSessionValid().then(valid => {
        if (!valid) return null;

        let jreq = {
          sessionId: this.$store.state.appSessionID,
          sessionKey: this.$store.state.store.sessionKey,
          feed: feed,
          debug: this.$devEnv,
        };
        let request = JSON.stringify(jreq);

        let fn = "addfeed";
        if (this.$store.state.serverBuildNo >= 183) fn = "v2/addorder";

        return axios
          .post(this.$store.state.doApiUrl + fn, request, this.$store.state.httpReqOpt)
          .then(result => result.data)
          .then(data => {
            return data;
          })
          .catch(error => {
            console.log(error);
          });
      });
    },

    rest_getOrders(phone) {
      return this.isSessionValid().then(valid => {
        if (!valid) return null;

        let sessionKey = this.$store.state.appSessionKey;
        if (this.$appMode == 0) sessionKey = this.$store.state.store.sessionKey;
        let jreq = {
          sessionId: this.$store.state.appSessionID,
          sessionKey: sessionKey,
          phone: phone,
          debug: this.$devEnv,
        };
        let request = JSON.stringify(jreq);

        let fn = "v2/getorders";
        return axios
          .post(this.$store.state.doApiUrl + fn, request, this.$store.state.httpReqOpt)
          .then(result => result.data)
          .then(data => {
            return data;
          })
          .catch(error => {
            console.log(error);
          });
      });
    },

    rest_getMember(phoneID) {
      return this.isSessionValid().then(valid => {
        if (!valid) return null;

        let jreq = {
          sessionId: this.$store.state.appSessionID,
          sessionKey: this.$store.getters.serviceSessionKey,
          phoneId: phoneID,
          debug: this.$devEnv,
        };
        let request = JSON.stringify(jreq);

        return axios
          .post(this.$store.state.dcApiUrl + "memberget", request, this.$store.state.httpReqOpt)
          .then(result => result.data)
          .then(data => {
            let respGet = data.get;
            if (respGet.result == "ok" && respGet.record != null && respGet.record.child != null) {
              // unknown issue, phoneid is missing in child, work around: add phoneid from header
              if (respGet.record.child.PhoneId == "") respGet.record.child.PhoneId = respGet.PhoneId;
            }
            return respGet;
          })
          .catch(error => {
            console.log(error);
          });
      });
    },

    rest_getMemberByToken(idToken) {
      return this.isSessionValid().then(valid => {
        if (!valid) return null;

        let jreq = {
          sessionId: this.$store.state.appSessionID,
          sessionKey: this.$store.getters.serviceSessionKey,
          tokenId: idToken,
          skipAutoCreation: true,
          debug: this.$devEnv,
        };
        let request = JSON.stringify(jreq);

        return axios
          .post(this.$store.state.dcApiUrl + "memberget", request, this.$store.state.httpReqOpt)
          .then(result => result.data)
          .then(data => {
            let respGet = data.get;
            if (respGet.result == "ok" && respGet.record != null && respGet.record.child != null) {
              // unknown issue, phoneid is missing in child, work around: add phoneid from header
              if (respGet.record.child.PhoneId == "") respGet.record.child.PhoneId = respGet.PhoneId;
            }
            return respGet;
          })
          .catch(error => {
            console.log(error);
          });
      });
    },

    rest_putMember(member) {
      return this.isSessionValid().then(valid => {
        if (!valid) return null;

        let jreq = {
          sessionId: this.$store.state.appSessionID,
          sessionKey: this.$store.getters.serviceSessionKey,
          put: [
            {
              MemberCode: member.MemberCode,
              MemberLastName: member.MemberLastName,
              MemberFirstName: member.MemberFirstName,
              MemberEMail: member.MemberEMail,
              MonthOfBirth: member.MonthOfBirth,
              //SmsNews: member==null?undefined:member.SmsNews,
              SmsPromo: member == null ? undefined : member.SmsPromo,
            },
          ],
          debug: this.$devEnv,
        };
        let request = JSON.stringify(jreq);

        return axios
          .post(this.$store.state.dcApiUrl + "membership", request, this.$store.state.httpReqOpt)
          .then(result => result.data)
          .then(data => {
            return data.put[0];
          })
          .catch(error => {
            console.log(error);
          });
      });
    },

    rest_transferMember(memberFrom) {
      return this.isSessionValid().then(valid => {
        if (!valid) return null;

        let jreq = {
          sessionId: this.$store.state.appSessionID,
          sessionKey: this.$store.getters.serviceSessionKey,
          MemberCode: this.$store.state.member.MemberCode,
          ClosingMemberCode: memberFrom,
          debug: this.$devEnv,
        };
        let request = JSON.stringify(jreq);

        return axios
          .post(this.$store.state.dcApiUrl + "membertransfer", request, this.$store.state.httpReqOpt)
          .then(result => result.data)
          .then(data => {
            return data;
          })
          .catch(error => {
            console.log(error);
          });
      });
    },

    rest_redeemMemberPoints(memberCode, points) {
      return this.isSessionValid().then(valid => {
        if (!valid) return null;

        let jreq = {
          sessionId: this.$store.state.appSessionID,
          sessionKey: this.$store.getters.serviceSessionKey,
          add: [{ MemberCode: memberCode, Amount: -points, Remark: "Redeem" }],
          debug: this.$devEnv,
        };
        let request = JSON.stringify(jreq);

        return axios
          .post(this.$store.state.dcApiUrl + "memberpointtrans", request, this.$store.state.httpReqOpt)
          .then(result => result.data)
          .then(data => {
            return data.add[0];
          })
          .catch(error => {
            console.log(error);
          });
      });
    },

    //obsolated, replaced by member/action/getGiftcards
    rest_getMemberGiftcards(memberCode) {
      return this.isSessionValid().then(valid => {
        if (!valid) return null;

        let jreq = {
          sessionId: this.$store.state.appSessionID,
          sessionKey: this.$store.getters.serviceSessionKey,
          list: [{ MemberCode: memberCode }],
          debug: this.$devEnv,
        };
        let request = JSON.stringify(jreq);

        return axios
          .post(this.$store.state.dcApiUrl + "giftcard", request, this.$store.state.httpReqOpt)
          .then(result => result.data)
          .then(data => {
            return data.list[0];
          })
          .catch(error => {
            console.log(error);
          });
      });
    },

    rest_addMemberGiftcard(memberCode, amount) {
      return this.isSessionValid().then(valid => {
        if (!valid) return null;

        let jreq = {
          sessionId: this.$store.state.appSessionID,
          sessionKey: this.$store.getters.serviceSessionKey,
          add: [{ MemberCode: memberCode, Amount: amount }],
          debug: this.$devEnv,
        };
        let request = JSON.stringify(jreq);

        return axios
          .post(this.$store.state.dcApiUrl + "giftcard", request, this.$store.state.httpReqOpt)
          .then(result => result.data)
          .then(data => {
            return data.add[0];
          })
          .catch(error => {
            console.log(error);
          });
      });
    },

    rest_getMemberGiftcardTrans(memberCode, cardCode) {
      return this.isSessionValid().then(valid => {
        if (!valid) return null;

        let jreq = {
          sessionId: this.$store.state.appSessionID,
          sessionKey: this.$store.getters.serviceSessionKey,
          storeSessionKey: this.$store.state.store != null ? this.$store.state.store.sessionKey : undefined,
          list: [{ MemberCode: memberCode, CardCode: cardCode, RecLimit: 50 }],
          debug: this.$devEnv,
        };
        let request = JSON.stringify(jreq);

        return axios
          .post(this.$store.state.dcApiUrl + "giftcardtrans", request, this.$store.state.httpReqOpt)
          .then(result => result.data)
          .then(data => {
            return data.list[0];
          })
          .catch(error => {
            console.log(error);
          });
      });
    },

    rest_reloadMemberGiftcard(payload) {
      return this.isSessionValid().then(valid => {
        if (!valid) return null;

        let n_remark = "Reload";
        if (payload.remark != null) n_remark = payload.remark;
        let n_message = "Mobile order";
        if (payload.message != null) n_message = payload.message;
        let jreq = {
          sessionId: this.$store.state.appSessionID,
          sessionKey: this.$store.getters.serviceSessionKey,
          storeSessionKey: this.$store.state.store != null ? this.$store.state.store.sessionKey : undefined,
          add: [
            {
              CardCode: payload.cardCode,
              Amount: payload.amount,
              Remark: n_remark,
              Message: n_message,
              AutoCreation: true,
              Sms: {
                MembershipName: this.$store.getters.memberCompanyName,
                StoreName: this.$store.getters.storeName,
                SenderName: this.$store.getters.memberName,
                SenderPhoneId: this.$store.state.member.PhoneId,
                RecipientPhoneId: payload.recipientPhoneId,
                RecipientMessage: payload.recipientMessage,
              },
            },
          ],
          debug: this.$devEnv,
        };
        let request = JSON.stringify(jreq);
        return axios
          .post(this.$store.state.dcApiUrl + "giftcardtrans", request, this.$store.state.httpReqOpt)
          .then(result => result.data)
          .then(data => {
            return data.add[0];
          })
          .catch(error => {
            console.log(error);
          });
      });
    },

    rest_redeemMemberGiftcard(cardCode, redeemValue) {
      return this.isSessionValid().then(valid => {
        if (!valid) return null;

        let jreq = {
          sessionId: this.$store.state.appSessionID,
          sessionKey: this.$store.getters.serviceSessionKey,
          storeSessionKey: this.$store.state.store != null ? this.$store.state.store.sessionKey : undefined,
          add: [
            {
              CardCode: cardCode,
              Amount: -redeemValue,
              Remark: "Redeem",
              Message: "Mobile order",
              Sms: {
                MembershipName: this.$store.getters.memberCompanyName,
                StoreName: this.$store.getters.storeName,
                SenderName: this.$store.getters.memberName,
                SenderPhoneId: this.$store.state.member.PhoneId
              },
            },
          ],
          debug: this.$devEnv,
        };
        let request = JSON.stringify(jreq);
        return axios
          .post(this.$store.state.dcApiUrl + "giftcardtrans", request, this.$store.state.httpReqOpt)
          .then(result => result.data)
          .then(data => {
            return data.add[0];
          })
          .catch(error => {
            console.log(error);
          });
      });
    },

    rest_getMemberPointTrans(memberCode) {
      return this.isSessionValid().then(valid => {
        if (!valid) return null;

        let jreq = {
          sessionId: this.$store.state.appSessionID,
          sessionKey: this.$store.getters.serviceSessionKey,
          list: [{ MemberCode: memberCode, RecLimit: 50 }],
        };
        let request = JSON.stringify(jreq);

        return axios
          .post(this.$store.state.dcApiUrl + "memberpointtrans", request, this.$store.state.httpReqOpt)
          .then(result => result.data)
          .then(data => {
            return data.list[0];
          })
          .catch(error => {
            console.log(error);
          });
      });
    },

    rest_getMemberPromos(memberCode, companyCode) {
      return this.isSessionValid().then(valid => {
        if (!valid) return null;

        let n_companyCode = companyCode;
        if (n_companyCode === undefined && this.$store.state.store != null)
          n_companyCode = this.$store.state.store.companyCode;

        let jreq = {
          sessionId: this.$store.state.appSessionID,
          sessionKey: this.$store.getters.serviceSessionKey,
          get: { MemberCode: memberCode, Store: n_companyCode, Language: "all" },
          debug: this.$devEnv,
        };
        let request = JSON.stringify(jreq);

        return axios
          .post(this.$store.state.dcApiUrl + "promo", request, this.$store.state.httpReqOpt)
          .then(result => result.data)
          .then(data => {
            return data.get;
          })
          .catch(error => {
            console.log(error);
          });
      });
    },

    rest_getMemberPromo(memberCode, promoCode) {
      return this.isSessionValid().then(valid => {
        if (!valid) return null;

        let n_store = undefined;
        if (n_store === undefined && this.$store.state.store != null) n_store = this.$store.state.store.companyCode;

        let jreq = {
          sessionId: this.$store.state.appSessionID,
          sessionKey: this.$store.getters.serviceSessionKey,
          get: {
            MemberCode: memberCode,
            Store: n_store,
            PromoteCode: promoCode,
            Language: "all",
          },
          debug: this.$devEnv,
        };
        let request = JSON.stringify(jreq);

        return axios
          .post(this.$store.state.dcApiUrl + "promo", request, this.$store.state.httpReqOpt)
          .then(result => result.data)
          .then(data => {
            return data.get;
          })
          .catch(error => {
            console.log(error);
          });
      });
    },

    rest_redeemMemberPromo(memberCode, promo) {
      return this.isSessionValid().then(valid => {
        if (!valid) return null;

        let jreq = {
          sessionId: this.$store.state.appSessionID,
          sessionKey: this.$store.getters.serviceSessionKey,
          redeem: { MemberCode: memberCode, PromoteCode: promo.PromoteCode },
          debug: this.$devEnv,
        };
        let request = JSON.stringify(jreq);

        return axios
          .post(this.$store.state.dcApiUrl + "promo", request, this.$store.state.httpReqOpt)
          .then(result => result.data)
          .then(data => {
            return data.redeem;
          })
          .catch(error => {
            console.log(error);
          });
      });
    },

    rest_getNewsFeed() {
      return this.isSessionValid().then(valid => {
        if (!valid) return null;

        let n_store = undefined;
        if (this.$appMode == 0 && this.$store.state.store != null) n_store = this.$store.state.store.companyCode;
        let jreq = {
          sessionId: this.$store.state.appSessionID,
          sessionKey: this.$store.getters.serviceSessionKey,
          get: { Store: n_store, Language: "all" },
        };
        let request = JSON.stringify(jreq);

        let dcApiUrl = this.$store.state.dcApiUrl;
        let httpReqOpt = { ...this.$store.state.httpReqOpt };
        //dcApiUrl = "https://api.mrsdigi.com/digiCloud/v4a.php/dc/";
        //httpReqOpt = { ...this.$store.state.httpReqOpt, headers: { Authorization: "Basic dGVzdDE6MTIzNDU2" } };
        return axios
          .post(dcApiUrl + "newsfeed", request, httpReqOpt)
          .then(result => result.data)
          .then(data => {
            return data.get;
          })
          .catch(error => {
            console.log(error);
          });
      });
    },

    rest_addBooking(params) {
      return this.isSessionValid().then(valid => {
        if (!valid) return null;

        let locale;
        if (this.$store.state.languageSelected != null) locale = this.$store.state.languageSelected.locale;
        let jreq = {
          sessionId: this.$store.state.appSessionID,
          sessionKey: this.$store.getters.serviceSessionKey,
          storeSessionKey: this.$store.state.store != null ? this.$store.state.store.sessionKey : undefined,
          put: {
            Store: this.$store.getters.storeCompanyCode,
            StoreName: this.$store.getters.storeInfo.companyName,
            MemberCode: this.$store.state.member.MemberCode,
            PartyName: this.$store.getters.memberFullName,
            PartySize: params.partySize,
            ResSlotId: params.reserveSlotId,
            BookingTime: params.bookingTime,
            ContactPhone: params.contactPhone,
            Remark: params.remark,
            CustomData: {
              Locale: locale,
            },
          },
          debug: this.$devEnv,
        };
        let request = JSON.stringify(jreq);

        return axios
          .post(this.$store.state.dcApiUrl + "booking", request, this.$store.state.httpReqOpt)
          .then(result => result.data)
          .then(data => {
            return data.put;
          })
          .catch(error => {
            console.log(error);
          });
      });
    },

    rest_getBooking(reserve) {
      return this.isSessionValid().then(valid => {
        if (!valid) return null;

        let jreq = {
          sessionId: this.$store.state.appSessionID,
          sessionKey: this.$store.getters.serviceSessionKey,
          storeSessionKey: this.$store.state.store != null ? this.$store.state.store.sessionKey : undefined,
          get: {
            Store: this.$store.getters.storeCompanyCode,
            MemberCode: this.$store.state.member.MemberCode,
            BookingType: reserve ? "R" : "Q",
          },
          debug: this.$devEnv,
        };
        let request = JSON.stringify(jreq);

        return axios
          .post(this.$store.state.dcApiUrl + "booking", request, this.$store.state.httpReqOpt)
          .then(result => result.data)
          .then(data => {
            return data.get;
          })
          .catch(error => {
            console.log(error);
          });
      });
    },

    rest_getReserveSlot() {
      return this.isSessionValid().then(valid => {
        if (!valid) return null;

        let jreq = {
          sessionId: this.$store.state.appSessionID,
          sessionKey: this.$store.getters.serviceSessionKey,
          storeSessionKey: this.$store.state.store != null ? this.$store.state.store.sessionKey : undefined,
          get: {
            ReserveCode: this.$store.getters.storeCompanyCode,
          },
          debug: this.$devEnv,
        };
        let request = JSON.stringify(jreq);

        return axios
          .post(this.$store.state.dcApiUrl + "reserveslot", request, this.$store.state.httpReqOpt)
          .then(result => result.data)
          .then(data => {
            return data.get;
          })
          .catch(error => {
            console.log(error);
          });
      });
    },

    rest_getAvailReserve(bookingOn, partySize) {
      return this.isSessionValid().then(valid => {
        if (!valid) return null;

        let now = new Date();
        let today = this.toSQLDateString(now);

        let jreq = {
          sessionId: this.$store.state.appSessionID,
          sessionKey: this.$store.getters.serviceSessionKey,
          storeSessionKey: this.$store.state.store != null ? this.$store.state.store.sessionKey : undefined,
          avail: {
            ReserveCode: this.$store.getters.storeCompanyCode,
            BookingOn: bookingOn,
            TimeFrom: bookingOn == today ? this.toTimeString(now) : undefined,
            PartySize: partySize,
          },
          debug: this.$devEnv,
        };
        let request = JSON.stringify(jreq);

        return axios
          .post(this.$store.state.dcApiUrl + "booking", request, this.$store.state.httpReqOpt)
          .then(result => result.data)
          .then(data => {
            return data.avail;
          })
          .catch(error => {
            console.log(error);
          });
      });
    },

    rest_cancelBooking(bookingNo) {
      return this.isSessionValid().then(valid => {
        if (!valid) return null;

        let jreq = {
          sessionId: this.$store.state.appSessionID,
          sessionKey: this.$store.getters.serviceSessionKey,
          storeSessionKey: this.$store.state.store != null ? this.$store.state.store.sessionKey : undefined,
          put: {
            BookingNo: bookingNo,
            StoreName: this.$store.getters.storeInfo.companyName,
            Cancelled: true,
          },
          debug: this.$devEnv,
        };
        let request = JSON.stringify(jreq);

        return axios
          .post(this.$store.state.dcApiUrl + "booking", request, this.$store.state.httpReqOpt)
          .then(result => result.data)
          .then(data => {
            return data.put;
          })
          .catch(error => {
            console.log(error);
          });
      });
    },

    rest_getDistanceMatrix(coords1, coords2) {
      var origins = [coords1.latitude.toString() + "," + coords1.longitude.toString()];
      var destinations = [coords2.latitude.toString() + "," + coords2.longitude.toString()];
      let jreq = {
        origins: origins,
        destinations: destinations,
        key: this.$GDM_API_KEY,
      };
      let apiUrl = "https://api.mrsdigi.com/digiCloud/v4.php/gapi/distance";
      let request = JSON.stringify(jreq);

      return axios
        .post(apiUrl, request)
        .then(result => result.data)
        .then(data => {
          return data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    rest_requestSmsVerificationCode(phoneID) {
      return this.isSessionValid().then(valid => {
        if (!valid) return null;

        let n_sessionKey = this.$store.state.appSessionKey;
        if (this.$appMode == 0 && this.$store.state.store != null) n_sessionKey = this.$store.state.store.sessionKey;
        let jreq = {
          sessionId: this.$store.state.appSessionID,
          sessionKey: n_sessionKey,
          validate: { Phone: phoneID },
          debug: this.$devEnv,
        };
        let request = JSON.stringify(jreq);

        return axios
          .post(this.$store.state.dcApiUrl + "sms", request, this.$store.state.httpReqOpt)
          .then(result => result.data)
          .then(data => {
            return data;
          })
          .catch(error => {
            console.log(error);
          });
      });
    },

    rest_verifySmsVerificationCode(phoneID, vcode, vtoken) {
      return this.isSessionValid().then(valid => {
        if (!valid) return null;

        let n_sessionKey = this.$store.state.appSessionKey;
        if (this.$appMode == 0 && this.$store.state.store != null) n_sessionKey = this.$store.state.store.sessionKey;
        let jreq = {
          sessionId: this.$store.state.appSessionID,
          sessionKey: n_sessionKey,
          verify: { Phone: phoneID, Code: vcode, Token: vtoken },
          debug: this.$devEnv,
        };
        let request = JSON.stringify(jreq);

        return axios
          .post(this.$store.state.dcApiUrl + "sms", request, this.$store.state.httpReqOpt)
          .then(result => result.data)
          .then(data => {
            return data;
          })
          .catch(error => {
            console.log(error);
          });
      });
    },

    rest_canAcceptOrder(orderType, checkOrderLimit, deliveryDriveMin) {
      return this.isSessionValid().then(valid => {
        if (!valid) return null;

        let jreq = {
          sessionId: this.$store.state.appSessionID,
          sessionKey: this.$store.state.store.sessionKey,
          orderType: orderType,
          checkOrderLimit: checkOrderLimit,
          deliveryMin: deliveryDriveMin,
        };
        let request = JSON.stringify(jreq);

        let fn = "canacceptorder";
        return axios
          .post(this.$store.state.doApiUrl + fn, request, this.$store.state.httpReqOpt)
          .then(result => result.data)
          .then(data => {
            if (data.result == "ok") {
              if (data.businessHours != null)
                this.$set(this.$store.state.store.info.businessHours, data.currentDay, data.businessHours);
              if (data.orderHours != null) {
                if (data.orderType == this.$store.state.OT_DINEIN)
                  this.$set(this.$store.state.store.info.dineinHours, data.currentDay, data.orderHours);
                else if (data.orderType == this.$store.state.OT_TAKEOUT)
                  this.$set(this.$store.state.store.info.takeoutHours, data.currentDay, data.orderHours);
                else if (data.orderType == this.$store.state.OT_DELIVERY)
                  this.$set(this.$store.state.store.info.deliveryHours, data.currentDay, data.orderHours);
              }
              if (data.transportHours != null)
                this.$set(this.$store.state.store.info.transportHours, data.currentDay, data.transportHours);
            }
            return data;
          })
          .catch(error => {
            console.log(error);
          });
      });
    },

    rest_doorDashEstimate(params) {
      return this.isSessionValid().then(valid => {
        if (!valid) return null;

        let feed = this.orderToFeed();
        if (params.address != null) feed.address = params.address;
        if (params.deliveryTime != null) feed.deliveryTimeTz = this.toDate(params.deliveryTime).toISOString();

        let jreq = {
          sessionId: this.$store.state.appSessionID,
          sessionKey: this.$store.state.store.sessionKey,
          function: "estimate",
          feed: feed,
        };
        let request = JSON.stringify(jreq);

        return axios
          .post(this.$store.state.dcApiUrl + "doordashreq", request, this.$store.state.httpReqOpt)
          .then(result => result.data)
          .then(data => {
            return data;
          })
          .catch(error => {
            console.log(error);
          });
      });
    },

    rest_doorDashValidate() {
      return this.isSessionValid().then(valid => {
        if (!valid) return null;

        let feed = this.orderToFeed();
        let jreq = {
          sessionId: this.$store.state.appSessionID,
          sessionKey: this.$store.state.store.sessionKey,
          function: "validation",
          feed: feed,
        };
        let request = JSON.stringify(jreq);

        return axios
          .post(this.$store.state.dcApiUrl + "doordashreq", request, this.$store.state.httpReqOpt)
          .then(result => result.data)
          .then(data => {
            return data;
          })
          .catch(error => {
            console.log(error);
          });
      });
    },

    rest_ftsPutOrder() {
      return this.isSessionValid().then(valid => {
        if (!valid) return null;

        let address = this.$store.state.order.address;
        if (address == null) address = {};

        let addressUnit;
        if (address.unit != null && address.unit != "") addressUnit = "unit " + address.unit;

        let data = {
          customer: {
            name: this.$store.getters.memberName,
            email: this.$store.getters.memberEmail,
            phone: this.$store.getters.memberPhoneId,
            r_address1: address.street,
            r_address2: addressUnit,
            r_city: address.city,
            r_prov_state: address.province,
            r_country: "CA",
            r_postal_code: address.postal,
          },
          order: {},
        };

        let jreq = {
          sessionId: this.$store.state.appSessionID,
          sessionKey: this.$store.state.store.sessionKey,
          data: data,
        };
        let request = JSON.stringify(jreq);

        return axios
          .post(this.$store.state.dcApiUrl + "fts", request, this.$store.state.httpReqOpt)
          .then(result => result.data)
          .then(data => {
            return data;
          })
          .catch(error => {
            console.log(error);
          });
      });
    },

    rest_faceDriveGetQuote(params) {
      return this.isSessionValid().then(valid => {
        if (!valid) return null;

        let address = params.address == null ? null : params.address;
        let readyTime = params.readyAt == null ? new Date() : params.readyTime;

        let data = {
          //address_store: this.storeAddressString,
          //address_customer: this.addressToString(address),
          address_store: this.$store.getters.storeAddress,
          address_customer: address,
          store_ready_at: this.toSQLDateTimeString(readyTime),
          store_timezone: this.$store.getters.storeTimeZone,
        };

        let jreq = {
          sessionId: this.$store.state.appSessionID,
          sessionKey: this.$store.state.store.sessionKey,
          function: "getQuote",
          data: data,
          debug: this.$devEnv,
        };
        let request = JSON.stringify(jreq);

        return axios
          .post(this.$store.state.dcApiUrl + "facedrive", request, this.$store.state.httpReqOpt)
          .then(result => result.data)
          .then(data => {
            return data;
          })
          .catch(error => {
            console.log(error);
          });
      });
    },

    rest_faceDriveQueryOrder(faceDrive) {
      return this.isSessionValid().then(valid => {
        if (!valid) return null;

        let orderID = faceDrive.order_id;
        let companyCode = faceDrive.CompanyCode;

        let sessionKey = this.$appMode == 0 ? this.$store.state.store.sessionKey : null;
        if (sessionKey == null && companyCode != null) {
          for (let s of this.$store.state.stores.list) {
            if (s.companyCode == companyCode) {
              sessionKey = s.sessionKey;
              break;
            }
          }
        }

        let data = {
          order_id: orderID,
        };

        let jreq = {
          sessionId: this.$store.state.appSessionID,
          sessionKey: sessionKey,
          function: "queryOrder",
          data: data,
        };
        let request = JSON.stringify(jreq);

        return axios
          .post(this.$store.state.dcApiUrl + "facedrive", request, this.$store.state.httpReqOpt)
          .then(result => result.data)
          .then(data => {
            return data;
          })
          .catch(error => {
            console.log(error);
          });
      });
    },

    /*
    rest_doorDashDelivery() {
      let lastName = "";
      let firstName = "";
      let pickupPhoneNumber = this.storeAddress.tel;

      if ("lastName" in this.$store.state.order.login) lastName = this.$store.state.order.login.lastName;
      if ("firstName" in this.$store.state.order.login) firstName = this.$store.state.order.login.firstName;
      if (lastName == "" && firstName == "") firstName = this.$store.state.order.login.name;

      if (this.$isValidPhoneNumber(pickupPhoneNumber)) pickupPhoneNumber = "+1" + pickupPhoneNumber;

      let data = {
        pickup_address: {
          unit: this.$store.getters.storeAddress.unit,
          street: this.$store.getters.storeAddress.street,
          city: this.$store.getters.storeAddress.city,
          state: this.$store.getters.storeAddress.province,
          zip_code: this.$store.getters.storeAddress.postal,
        },
        pickup_phone_number: pickupPhoneNumber,
        dropoff_address: {
          unit: this.$store.state.order.address.unit,
          street: this.$store.state.order.address.street,
          city: this.$store.state.order.address.city,
          state: this.$store.state.order.address.province,
          zip_code: this.$store.state.order.address.postal,
        },
        dropoff_instructions: this.$store.state.order.address.remark,
        delivery_time: this.$store.state.order.deliveryTimeTz,
        order_value: Math.floor(this.$store.state.order.subtotal * 100),
        tip: Math.floor(this.$store.state.order.tips * 100),
        customer: {
          first_name: firstName,
          last_name: lastName,
          phone_number: this.$store.state.order.login.phone1,
        },
      };
      let jreq = {
        sessionId: this.$store.state.appSessionID,
        sessionKey: this.$store.state.store.sessionKey,
        DriveId: this.$store.state.order.doorDashDriveID,
        delivery: { data: data },
      };
      let request = JSON.stringify(jreq);

      return axios
        .post(this.$store.state.dcApiUrl + "doordash", request, this.$store.state.httpReqOpt)
        .then((result) => result.data)
        .then((data) => {
          return data.delivery;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    */
  },
};
